import { ACv5 } from '@confluence/wrm';

export function atlassianConnect() {
	// noop. All comes from WRM.
}

export function atlassianConnectWRM() {
	return ACv5;
}
